export class Steps {
  get progress() {
    return (this.current * 100) / (this.total + 1);
  }

  constructor(public total, public current = 1) {}

  isPrevious() {
    return this.current > 1;
  }

  isNext() {
    return this.current < this.total;
  }

  isActive(step: number) {
    return this.current === step;
  }

  set(step: number) {
    this.current = step;
  }

  previous() {
    if (!this.isPrevious()) {
      return;
    }

    this.set(this.current - 1);
  }

  next() {
    if (!this.isNext()) {
      return;
    }

    this.set(this.current + 1);
  }
}



// WEBPACK FOOTER //
// ./src/app/booking-management/booking-form/steps.ts